import { memo } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { useVisibleDropZones } from "../Hooks/useVisibleDropZones";
import { DropZoneController } from "./DropZoneController";
import { FloatingDropZoneItem } from "./FloatingDropZoneItem";

export const FloatingDropZones = memo(() => {
  const dragAndDropType = useBuilderStore(state => state.dragAndDropType);
  const visibleDropZones = useVisibleDropZones();

  return (
    <>
      <DropZoneController />
      {dragAndDropType === "floating-dropzones"
        ? visibleDropZones.map(position => (
            <FloatingDropZoneItem
              key={`${position.path}:${position.index}`}
              {...position}
            />
          ))
        : null}
    </>
  );
});

FloatingDropZones.displayName = "FloatingDropZones";
